import { render, staticRenderFns } from "./jifenoo.vue?vue&type=template&id=42234297&scoped=true"
import script from "./jifenoo.vue?vue&type=script&lang=js"
export * from "./jifenoo.vue?vue&type=script&lang=js"
import style0 from "./jifenoo.vue?vue&type=style&index=0&id=42234297&prod&lang=scss&scoped=true"
import style1 from "./jifenoo.vue?vue&type=style&index=1&id=42234297&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42234297",
  null
  
)

export default component.exports